import React, { useState } from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';

import { useUserPermission } from '@contexts/UserContext';

import { forceReloadPayment } from '@hooks/API/UsePayments';

import Money from '@components/Gui/Money';
import { NwLinkButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';
import PrintPaymentButton from '@components/Payments/PrintPaymentButton';

import EditPaymentNumberDrawer from './EditPaymentNumberDrawer';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    .confirmation-payment-and-export {
        display: flex;
        flex-direction: row;
        padding: 1rem 0 2rem 0;
        width: 100%;

        .payment-top-box {
            display: flex;
            padding-right: 2rem;
            align-items: center;
            justify-content: flex-start;
            flex: 1 1 0;

            .payment-top-box-icon {
                margin-right: 2rem;
                font-size: 2rem;
            }

            .payment-top-box-content {
                .payment-top-box-title {
                    font-weight: bold;
                    font-size: ${(props) => props.theme.FontSizeLg};
                }
                small {
                    max-width: 13rem;
                    font-size: ${(props) => props.theme.FontSizeSm};
                    display: block;
                    opacity: 0.5;
                    line-height: 1.1em;
                }
            }
        }

        .payment-top-export {
            display: flex;
            gap: 2rem;
        }
    }
`;

const PaymentPageTop = ({ paymentData }) => {
    const [showPaymentNumberDrawer, setShowPaymentNumberDrawer] = useState(false);

    const canPost = useUserPermission('PostPayments');

    const setAsReadyToPost = async () => {
        await Axios.put(`/Payments/SetReadyToPost`, { PaymentID: paymentData.ID, ReadyToPost: true });
        forceReloadPayment(paymentData.ID);
    };

    return (
        <>
            <Wrapper>
                <div className="confirmation-payment-and-export">
                    <div className="payment-top-box">
                        <div className="payment-top-box-content">
                            <div className="payment-top-box-title">{paymentData.Number}</div>
                            <div>Payment Date: {getMoment(paymentData.Date).format('DD MMM YYYY')} </div>

                            <NwLinkButton
                                onClick={() => setShowPaymentNumberDrawer(true)}
                                label="Change number/code and date"
                            />
                        </div>
                    </div>
                    <div className="payment-top-box">
                        <div className="payment-top-box-content">
                            <div>Amount paid</div>
                            <div className="payment-top-box-title">
                                <Money amount={paymentData.TotalAmount} currency={paymentData.Currency} />
                            </div>
                        </div>
                    </div>
                    <div className="payment-top-export">
                        <div className="payment-top-export-icon">
                            <PrintPaymentButton
                                paymentType={paymentData.Type}
                                paymentID={paymentData.ID}
                                placement="leftTop"
                            />
                        </div>
                        <div className="invoice-top-export-icon">
                            <NwIcon
                                disabled={!canPost}
                                size="2x"
                                icon={byPrefixAndName.fasl['file-export']}
                                onClick={setAsReadyToPost}
                                tooltip="set this payment as ready to post"
                                pointer
                            />
                        </div>
                        <div className="payment-top-download-icon">
                            <NwIcon disabled size="2x" icon={byPrefixAndName.fasl['cloud-arrow-down']} />
                        </div>
                    </div>
                </div>
            </Wrapper>
            {showPaymentNumberDrawer && (
                <EditPaymentNumberDrawer
                    paymentID={paymentData.ID}
                    paymentContactID={paymentData.ContactID}
                    number={paymentData.Number}
                    date={paymentData.Date}
                    onClose={() => setShowPaymentNumberDrawer(false)}
                />
            )}
        </>
    );
};

export default PaymentPageTop;
